<template>
    <div class="row recent-orders">
        <div class="row mb-5">
            <div class="col-12">
                <button
                    class="btn filter-btn"
                    @click="
                        filterType = 'all';
                        getResults();
                    "
                    :class="filterType == 'all' ? 'active' : ''"
                >
                    ALL QUOTES
                </button>
                <button
                    class="btn filter-btn"
                    @click="
                        filterType = 'approved';
                        getResults();
                    "
                    :class="filterType == 'approved' ? 'active' : ''"
                >
                    APPROVED
                </button>
                <button
                    class="btn filter-btn"
                    @click="
                        filterType = 'pending approval';
                        getResults();
                    "
                    :class="filterType == 'pending approval' ? 'active' : ''"
                >
                    PENDING APPROVAL
                </button>
                <button
                    class="btn filter-btn"
                    @click="
                        filterType = 'confirmed';
                        getResults();
                    "
                    :class="filterType == 'confirmed' ? 'active' : ''"
                >
                    CONFIRMED
                </button>
                <button
                    class="btn filter-btn"
                    @click="
                        filterType = 'converted';
                        getResults();
                    "
                    :class="filterType == 'converted' ? 'active' : ''"
                >
                    CONVERTED
                </button>
            </div>
        </div>
        <div class="col-md-12">
            <div class="row">
                <div class="col-sm-12 col-md-7">
                    <h3>Quotes</h3>
                </div>
                <div class="col-sm-12 col-md-3 text-right">
                    <div class="form-group">
                        <div class="input-group search-field">
                            <input
                                class="form-control"
                                type="text"
                                @input="handleSearch()"
                                placeholder="Search Quotes"
                                v-model="searchTerm"
                                autocomplete="off"
                            />
                            <div class="input-group-prepend">
                                <span class="input-group-text"
                                    ><i class="fas fa-search"></i
                                ></span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-sm-12 col-md-2 text-right">
                    <router-link
                        class="btn add-button btn btn-action w-100"
                        to="/create-quote"
                    >
                        CREATE QUOTE
                    </router-link>
                </div>
            </div>
            <div class="row mt-3">
                <div class="col-sm-12 text-right top-area">
                    <Bootstrap4Pagination
                        :data="paginatedAllQuotes"
                        @pagination-change-page="getResults"
                        :align="'right'"
                    >
                        <template #prev-nav>
                            <i class="fa fa-arrow-left"></i> PREVIOUS</template
                        >
                        <template #next-nav>
                            NEXT <i class="fa fa-arrow-right"></i>
                        </template>
                    </Bootstrap4Pagination>
                </div>
            </div>
            <table
                class="table table-responsive table-striped border-bottom mt-2"
            >
                <thead class="thead-light">
                    <tr>
                        <th style="width: 5em">Quote</th>
                        <th style="width: 5em">RDD</th>
                        <th>Dealer Name</th>
                        <th style="width: 10em">Created By</th>
                        <th style="width: 10em">Date Created</th>
                        <th style="width: 15em">
                            Total Gross Margin on Sale - <br />Revenue
                        </th>
                        <th style="width: 15em">
                            Total Gross Margin on Sale - <br />Cost
                        </th>
                        <th style="width: 15em">
                            Total Gross Margin on Sale - <br />Gross Margin %
                        </th>
                        <th>Status</th>
                        <th style="width: 20em">Approved By</th>
                        <th style="width: 10em"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="quote in paginatedAllQuotes.data" :key="quote.id">
                        <td class="hyperlink" @click="viewQuote(quote)">
                            {{ quote.id }}
                        </td>
                        <td>{{ quote.requested_delivery_date ?? quote.created_at }}</td>
                        <td>{{ quote.location.name }}</td>
                        <td>{{ quote.user.name }}</td>
                        <td>{{ quote.created_at }}</td>
                        <td>
                            ${{
                                $filters.moneyFormat(
                                    quote.total_gross_margin_on_sale_revenue
                                )
                            }}
                        </td>
                        <td>
                            ${{
                                $filters.moneyFormat(
                                    quote.total_gross_margin_on_sale_cost
                                )
                            }}
                        </td>
                        <td>
                            {{
                                $filters.percentFormat(
                                    quote.total_gross_margin_on_sale_gm_percent
                                )
                            }}%
                        </td>
                        <td>{{ quote.status }}</td>
                        <!-- <td>{{ quote.approved_by?.name }}</td> -->
                        <td>
                            <template
                                v-for="approval in quote.quote_approvals"
                                :key="approval.id"
                            >
                                <div class="d-flex align-items-center pb-1">
                                    <span>{{ approval.approved_by.name }}</span>
                                    <span class="pl-2"
                                        >({{
                                            $filters.dateTimeFormat(
                                                approval.created_at
                                            )
                                        }})</span
                                    >
                                </div>
                            </template>
                            {{ quote.approved_by?.name }}
                        </td>
                        <td style="width: 20px" class="text-right">
                            <span
                                class="px-1 view-action"
                                @click="viewQuote(quote)"
                                ><i class="fa fa-eye" aria-hidden="true"></i>
                                VIEW<br
                            /></span>
                            <span
                                class="px-1 view-action"
                                @click="confirmModal(quote)"
                                ><i class="fa fa-trash" aria-hidden="true"></i>
                                DELETE</span
                            >
                        </td>
                    </tr>
                </tbody>
            </table>

            <Bootstrap4Pagination
                :data="paginatedAllQuotes"
                @pagination-change-page="getResults"
                :align="'right'"
                :limit="1"
                :keepLength="true"
            >
                <template #prev-nav>
                    <i class="fa fa-arrow-left"></i> PREVIOUS</template
                >
                <template #next-nav>
                    NEXT <i class="fa fa-arrow-right"></i>
                </template>
            </Bootstrap4Pagination>

            <!-- Pagination -->
            <!-- <table-pagination
                v-model="paginatedAllQuotes"
                :all-rows="searchAllQuotesbyTerm"
                :perPage="perPage"
                @updateRow="updateRow"
            >
            </table-pagination> -->
        </div>

        <!-- Confirmation modal -->
        <b-modal v-model="modalShowConfirm" hide-footer>
            <Confirmation
                v-if="modalShowConfirm"
                :title="'Are you sure you want to delete this quote?'"
                @custom-func="deleteQuoteById"
                @close-modal="closeModalConfirm"
            />
        </b-modal>
    </div>
</template>

<script>
import { computed, onMounted } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import TablePagination from "@/components/TablePagination.vue";
import { Bootstrap4Pagination } from "laravel-vue-pagination";

import Confirmation from "@/components/Confirmation.vue";

export default {
    props: [],
    emits: [],
    components: {
        TablePagination,
        Confirmation,
        Bootstrap4Pagination
    },
    setup() {
        const store = useStore();
        const route = useRoute();

        let user = computed(function () {
            return store.state.user;
        });
        let allQuotes = computed(function () {
            return store.state["quote"].allQuotes;
        });

        function getAllQuotes() {
            store.dispatch("quote/getAllQuotes");
        }

        onMounted(() => {});

        return {
            store,
            route,
            user,
            allQuotes,
            getAllQuotes,
        };
    },
    data() {
        return {
            paginatedAllQuotes: [],
            perPage: 50,
            searchTerm: "",
            searchStatus: "all",
            modalShowConfirm: false,
            reqQuote: {
                id: null,
                location_id: null,
            },
            filterType: "all",
            debouncedFunction: null,
        };
    },
    computed: {
        searchAllQuotesbyTerm() {
            if (this.searchTerm === "") {
                return this.allQuotes;
            }

            var filterArr = [];

            if (this.searchTerm !== "") {
                this.allQuotes.forEach((quote) => {
                    if (
                        quote.location.name
                            .toLowerCase()
                            .includes(this.searchTerm.toLowerCase()) ||
                        quote.user.name
                            .toLowerCase()
                            .includes(this.searchTerm.toLowerCase()) ||
                        quote.status
                            .toLowerCase()
                            .includes(this.searchTerm.toLowerCase())
                    ) {
                        filterArr.push(quote);
                    }
                });
            }

            return filterArr;
        },
    },
    watch: {
        paginatedAllQuotes(newVal, oldVal) {
            // this.onPageChanged(newPage);
        },
    },
    mounted() {
        // if (this.user.quote_access || ['super_admin','quote_approver','sales_admin'].includes(this.user.role.name)) {
        if (this.user.quote_access || this.user.role_modules.includes('Quotes')) {
            // this.getAllQuotes();
            this.getResults();
        } else {
            this.$router.push({ name: "dashboard" });
        }
    },
    methods: {
        updateRow(val) {
            this.paginatedAllQuotes = val;
        },
        viewQuote(quote) {
            this.$router.push({
                name: "quoteInfo",
                params: { id: quote.id },
            });
        },
        editQuote(quote) {
            this.$router.push({
                name: "quoteEdit",
                params: { id: quote.id },
            });
        },
        confirmModal(quote) {
            this.reqQuote = {
                id: quote.id,
            };
            this.modalShowConfirm = !this.modalShowConfirm;
        },
        deleteQuoteById() {
            this.store
                .dispatch("quote/deleteQuote", this.reqQuote)
                .then((resp) => {
                    window.emitter.emit("alertSuccess", {
                        message: "Quote deleted successfully!",
                    });
                });
        },
        closeModalConfirm() {
            this.modalShowConfirm = !this.modalShowConfirm;
        },
        onChange() {
            this.searchQuotes({
                searchTerm: this.searchTerm,
            });
        },
        getResults(page = 1) {
            let searchTerm = this.searchTerm;
            axios
                .get(
                    "/api/get-all-quotes-paginated?page=" +
                        page +
                        "&search=" +
                        searchTerm +
                        "&filterType=" +
                        this.filterType
                )
                .then((res) => {
                    this.paginatedAllQuotes = res.data;
                })
                .catch((err) => {});
        },
        handleSearch() {
            if (this.debouncedFunction) {
                clearTimeout(this.debouncedFunction);
            }
            this.debouncedFunction = setTimeout(() => {
                this.getResults(1);
            }, 500);
        },
    },
};
</script>
